import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spinner } from "react-bootstrap";
import { TablePlaceholder } from "../../components/placeholders";
import { formatCurrency } from "../../helpers/utils";
import { TABLE_COLUMN_WIDTHS } from "../../helpers/tableColumnWidths";
import ImageWithLoader from "../../components/image";
import CustomLoader from "../../components/loader";

const styles = {
  table: {
    className: "table table-centered mb-0",
  },
  thCenter: (width) => ({
    textAlign: "center",
    width: width,
  }),
  tdCenter: (width) => ({
    textAlign: "center",
    width: width,
  }),
  actionButton: {
    background: "none",
    border: "none",
    padding: 0,
  },
  loaderWrapper: {
    textAlign: "center",
    padding: "0.5rem",
  },
  endMessage: {
    textAlign: "center",
    color: "#6c757d", // bootstrap text-muted
    marginTop: "2rem",
    fontSize: 13,
  },
};

export default function ProductTable({
  items,
  loading,
  hasMore,
  onEndReached,
  loadingProductId,
  handleVisible,
  onEdit,
  onDelete,
}) {
  const COLUMN_WIDTHS = TABLE_COLUMN_WIDTHS.editTalbe;

  return (
    <div className="table-responsive-sm">
      <InfiniteScroll
        dataLength={items?.length || 0}
        next={onEndReached}
        hasMore={hasMore}
        scrollThreshold={0.9}
        loader={
          <div style={styles.loaderWrapper}>
            <CustomLoader fontSize={32} />
          </div>
        }
        endMessage={
          !hasMore && <p style={styles.endMessage}>Төгсгөлд нь хүрсэн байна</p>
        }
      >
        <table className={styles.table.className}>
          <thead>
            <tr>
              <th style={styles.thCenter(COLUMN_WIDTHS.active)}>Идэвхтэй</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.image)}>Зураг</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.name)}>Нэр</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.price)}>Үнэ</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.stock)}>Үлдэгдэл</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.edit)}>Засах</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.delete)}>Устгах</th>
            </tr>
          </thead>
          <tbody>
            {loading && items.length === 0 ? (
              <TablePlaceholder rows={12} count={7} />
            ) : (
              items?.map((item) => {
                const isUpdating = loadingProductId === item.id;

                return (
                  <tr key={item.id}>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.active)}>
                      {isUpdating ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          role="status"
                          className="ms-3"
                        />
                      ) : (
                        <div>
                          <input
                            type="checkbox"
                            id={`switch_${item.id}`}
                            checked={item.isVisible}
                            data-switch="danger"
                            onChange={(e) => handleVisible(e, item.id)}
                          />
                          <label
                            htmlFor={`switch_${item.id}`}
                            data-on-label="On"
                            data-off-label="Off"
                          />
                        </div>
                      )}
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.image)}>
                      <ImageWithLoader
                        src={item.image}
                        alt={item.name}
                        width="40px"
                        height="40px"
                        className="avatar-sm"
                      />
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.name)}>
                      {item.name}
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.price)}>
                      {formatCurrency(item.price)}
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.stock)}>
                      {item.quantity}
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.edit)}>
                      <button
                        className="action-icon"
                        onClick={() => onEdit(item)}
                        style={styles.actionButton}
                      >
                        <i className="mdi mdi-square-edit-outline" />
                      </button>
                    </td>
                    <td style={styles.tdCenter(COLUMN_WIDTHS.delete)}>
                      <button
                        className="action-icon text-danger"
                        onClick={() => onDelete(item)}
                        style={styles.actionButton}
                      >
                        <i className="mdi mdi-delete-outline" />
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  );
}
